<template lang="html">
  <MaterialCard
    :title='rate ? rate.name : "Create New Rate"'
    dark
    hover
    color='busie'
    @click="$emit('click', $event)">
    <v-layout justify-left wrap>
      <v-flex
        v-for="(value, propertyName) in rate"
        v-if='display(propertyName)'
        :key='propertyName'
        xs6>
        <v-layout wrap>
          <div class="property">
            <div class='ml-4 mt-1'>{{ fieldLabel(propertyName)}}</div>
            <div class='mt-1 mb-4 ml-5'>
              {{ displayUnits(propertyName).prependUnit }}
              {{ value }}
              {{ displayUnits(propertyName).appendUnit }}
            </div>
          </div>
        </v-layout>
        <!-- <div class='property'>
          {{ fieldLabel(propertyName) }}:
          <span v-if="propertyName != 'name'"> $ </span>
          {{value}}
        </div> -->
      </v-flex>
    </v-layout>
    <v-layout justify-center v-if='!rate' pa-5>
      <v-icon large dark>
        mdi-plus-circle
      </v-icon>
    </v-layout>
  </MaterialCard>
</template>

<script>
import MaterialCard from '@/components/material/Card';
import label from '@/utils/label';

export default {
  components: {
    MaterialCard
  },
  props: {
    rate: { required: false, type: Object},
  },
  data: () => ({
    units: {
      live_rate: {
        prependUnit: '$',
        appendUnit: '/mile'
      },
      dead_rate: {
        prependUnit: '$',
        appendUnit: '/mile'
      },
      layover: {
        prependUnit: '$',
        appendUnit: '/night'
      },
      extra_driver: {
        prependUnit: '$',
        appendUnit: null
      },
      misc_cost: {
        prependUnit: '$',
        appendUnit: null
      },
      hourly: {
        prependUnit: '$',
        appendUnit: '/hour'
      },
      gratituity: {
        prependUnit: null,
        appendUnit: '%'
      },
      day_rate: {
        prependUnit: '$',
        appendUnit: null
      },
      leg_rate: {
        prependUnit: '$',
        appendUnit: null
      }
    }
  }),
  computed: {
    fieldLabel: () => propertyName => label(propertyName),
    display: () =>
      propertyName => !['id', 'type', 'dispatch', 'name', 'saved'].includes(propertyName),
    displayUnits () {
      return propertyName => this.units[propertyName]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
